// import lazyLoading from '../lazyLoading';

export default {
  name: 'why',
  caption: 'Why',
  wdm16_id: '',
  icon: 'icon-question',
  path: '/why',
  // component: lazyLoading('patient/index'),
  required: [],
  permissions: [],
  meta: {
    required: [],
    icon: 'fa-bars',
    expanded: false
  }
};
